import { Injectable } from "@angular/core";
import { Adapter } from "../adapter";
import { LTSAEvergreen } from "./constants";


export class UnitLTSASearch {
    constructor(
        public unitLtsaId: string,
        public contractLength: string,
        public contractLengthDesc: string,
        public contractExpiration: string,
        public ltsaStatusId: string,
        public ltsaStatusDesc: string,
        public recordStatusId: string,
        public recordStatusDesc: string,
        public contractorId: string,
        public contractorName: string,
        public unitLtsaTypeId: string,
        public unitLtsaTypeDesc: string,
        public hasLtsa: string,
        public preferredContractor: string,
        public qcDate: string,
        public physAddressV1: string,
        public mailAddressV1: string,
        public plantId: string,
        public plantName: string,
        public offshoreBlockV1: string
    ) { }
}

@Injectable({
    providedIn: 'root',
})
export class UnitLTSASearchAdapter implements Adapter<UnitLTSASearch> {
    adapt(item: any): UnitLTSASearch {
        return new UnitLTSASearch(
            item.UNIT_LTSA_ID, 
            item.CONTRACT_LENGTH,
            item.CONTRACT_LENGTH === LTSAEvergreen.Code ? LTSAEvergreen.Letter : item.CONTRACT_LENGTH, 
            item.CONTRACT_EXPIRATION,
            item.LTSA_STATUS_ID, 
            item.LTSA_STATUS_DESC, 
            item.RECORD_STATUS, 
            item.RECORD_STATUS_DESC, 
            item.SERVICE_CONTRACTOR_ID, 
            item.SERVICE_CONTRACTOR_NAME,
            item.UNIT_LTSA_TYPE_ID, 
            item.UNIT_LTSA_TYPE_DESC,
            item.HAS_LTSA, 
            item.PREFERRED_CONTRACTOR, 
            item.QC_DATE,
            item.PHYS_ADDRESS_V1, 
            item.MAIL_ADDRESS_V1,
            item.PLANT_ID, 
            item.PLANT_NAME, 
            item.OFFSHORE_BLOCK_V1 
        );
    }
}


